$(document).ready(function ($) {
    $('#mobile-menu-toggle').on('click', function () {
        $('#mobile-menu').removeClass('hidden');
        $('#menu-icon').addClass('hidden');
        $('#close-icon').removeClass('hidden');
        $('body').addClass('overflow-hidden');
    });

    $('#mobile-menu-close, #mobile-menu-backdrop').on('click', function () {
        $('#mobile-menu').addClass('hidden');
        $('#menu-icon').removeClass('hidden');
        $('#close-icon').addClass('hidden');
        $('body').removeClass('overflow-hidden');
    });
});
